<script lang="ts">
  import { AppState } from '../../etc/stores';

  export let theme = '';

  const getBorderColor = () => {
    return `border-color: ${$AppState.theme.colors.illustration.quinary}4d`;
  };

  const getStyle = () => {
    if (
      (theme || $AppState.website.iconsBackground) ===
      'light-without-background'
    ) {
      return getBorderColor();
    }
  };
</script>

<div
  class={`twism-themed-icon ${theme || $AppState.website.iconsBackground}`}
  style={getStyle()}
>
  <div class="twism-themed-icon-content">
    <slot />
  </div>
</div>

<style lang="scss">
  .twism-themed-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: transparent;
    position: relative;
    overflow: hidden;

    &-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 5;
    }

    &.themed {
      background: var(--twism-theme-secondaryBackground);

      :global(svg path) {
        fill: #fff;
      }

      @media screen and (min-width: 768px) {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          pointer-events: none;
          background: rgba(0, 0, 0, 0.1);
          transition: opacity 0.2s ease-in-out;
        }

        &:hover:before {
          opacity: 1;
        }
      }
    }

    &.light {
      background: #fff;
      border: 1px solid var(--twism-theme-slightBorder);
      transition: background 0.2s ease-in-out;

      :global(svg path) {
        fill: var(--twism-theme-secondary);
      }

      @media screen and (min-width: 768px) {
        &:hover {
          background: darken(#fff, 4%);
        }
      }
    }

    &.light-without-background {
      border: 1px solid var(--twism-theme-illustration-quinary);
      transition: background 0.2s ease-in-out;

      :global(svg path) {
        fill: var(--twism-theme-illustration-quinary);
      }

      @media screen and (min-width: 768px) {
        &:hover {
          background: rgba(0, 0, 0, 0.04);
        }
      }
    }

    &.outline {
      border: 1px solid var(--twism-theme-slightBorder);
      transition: background 0.2s ease-in-out;

      :global(svg path) {
        fill: #fff;
      }

      @media screen and (min-width: 768px) {
        &:hover {
          background: rgba(0, 0, 0, 0.04);
        }
      }
    }

    &.none {
      background: none;

      :global(svg path) {
        fill: white;
      }
    }
  }
</style>
